import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { HttpErrorResponse } from '@angular/common/http';
import { Constants } from '../../../app.constants';
import { InsightsService } from '../../../services/insights.service';

@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css'],
})
export class PieChartComponent implements OnChanges {
  @Input() type = 'age';
  @Input() days = '30';

  loading = false;

  // Pie chart configuration
  public pieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.raw as number;
            const total = context.chart.data.datasets[0].data.reduce(
              (a, b) => (Number(a) || 0) + (Number(b) || 0),
              0,
            );
            const percentage = Math.round(
              (Number(value) / (Number(total) || 1)) * 100,
            );
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };

  public pieChartData: ChartData<'pie'> = {
    labels: [],
    datasets: [
      {
        data: [],

        backgroundColor: [
          '#344734',
          '#e7d1b5',
          '#f8e8d4',
          '#f1a638',
          '#4CAF50',
        ],
        hoverBackgroundColor: [
          '#344734',
          '#e7d1b5',
          '#f8e8d4',
          '#f1a638',
          '#4CAF50',
        ],
      },
    ],
  };

  public pieChartType: ChartType = 'pie';

  constructor(
    private insightService: InsightsService,
    private constants: Constants,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.getChartData();
  }

  getChartData(): void {
    this.loading = true;

    this.getAgeData();
  }

  private getAgeData(): void {
    this.insightService.getCustomerAge().subscribe({
      next: (response: any) => {
        if (response) {
          this.pieChartData = {
            labels: response.map((item: any) => item.label),
            datasets: [
              {
                data: response.map((item: any) => item.value),
                backgroundColor: [
                  '#344734',
                  '#e7d1b5',
                  '#f8e8d4',
                  '#f1a638',
                  '#4CAF50',
                ],
              },
            ],
          };
        }
      },
      error: (error) => {
        this.constants.snack(error.error.message);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
